import { useCallback } from 'react';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { UPDATE_ASSOCIATION_MODAL_STATES } from 'crm-message-bus/types/UpdateAssociationModalStates';
import { useCardContext } from '../context/CardContext';
import { usageTracker } from '../utils/usageTracker';
export const useHandleOpenEditAssociationModal = association => {
  const {
    fromObjectTypeId,
    fromObjectId
  } = useCardContext();
  const sendOpenUpdateAssociationModal = useSendCrmMessageTopic('OPEN_UPDATE_ASSOCIATION_MODAL');
  const handleOpenEditAssociationModal = useCallback(() => {
    usageTracker.track('CRM', 'Record Interactions', {
      type: 'Association Card',
      action: 'Opened Edit Association Modal',
      toObjectTypeId: association.objectTypeId,
      fromObjectTypeId
    });
    sendOpenUpdateAssociationModal({
      currentState: UPDATE_ASSOCIATION_MODAL_STATES.EDIT_ASSOCIATION_MODAL_STATE,
      fromObjectId,
      fromObjectTypeId,
      toObjectId: association.objectId,
      toObjectTypeId: association.objectTypeId
    });
  }, [sendOpenUpdateAssociationModal, fromObjectId, fromObjectTypeId, association.objectId, association.objectTypeId]);
  return {
    handleOpenEditAssociationModal
  };
};